/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type TerminationOfExistingContract = 'YesTerminationByUs' | 'NoFixedContratDuration' | 'NoTerminationMyself' | 'NoContractByAnother' | 'NoPlaceOfDeliveryNotConnected' | 'NoPlaceOfDeliveryNotExists';

export const TerminationOfExistingContract = {
    YesTerminationByUs: 'YesTerminationByUs' as TerminationOfExistingContract,
    NoFixedContratDuration: 'NoFixedContratDuration' as TerminationOfExistingContract,
    NoTerminationMyself: 'NoTerminationMyself' as TerminationOfExistingContract,
    NoContractByAnother: 'NoContractByAnother' as TerminationOfExistingContract,
    NoPlaceOfDeliveryNotConnected: 'NoPlaceOfDeliveryNotConnected' as TerminationOfExistingContract,
    NoPlaceOfDeliveryNotExists: 'NoPlaceOfDeliveryNotExists' as TerminationOfExistingContract
};